/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios";
import router from "@/router";
import { Toast } from "vant";

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: "/WxAuth",
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 * @param {String} message 请求失败的信息
 */
const errorHandle = (status, message) => {
  // 状态码判断
  switch (status) {
    case 401:
      tip("登录过期，重新登录");
      localStorage.removeItem("myToken");
      setTimeout(() => {
        toLogin();
      }, 500);
      break;
    case 403:
      tip("登录过期，重新登录");
      localStorage.removeItem("myToken");
      setTimeout(() => {
        toLogin();
      }, 500);
      break;
    case 404:
      tip("请求的资源不存在");
      break;
    case 500:
      tip("服务器挂了");
      break;
    case 30001:
      tip("openId不存在");
      break;
    case 30002:
      tip("你不是商户");
      break;
    case 30003:
      tip("账号不存在或密码错误");
      break;
    default:
      tip(message);
  }
};

// 创建axios实例
console.log(process.env.VUE_APP_BASE_API)
var instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000
});
// 设置post请求头
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 上传图片接口请求头不携带token
    if (config.url === process.env.VUE_APP_UPLOADIMG_API) {
      return config;
    }
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    const token = localStorage.getItem("myToken");
    config.headers.common["Access-Token"] = token;
    return config;
  },
  error => Promise.error(error)
);

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    if (res.config.url === process.env.VUE_APP_UPLOADIMG_API) {
      return Promise.resolve(res.data);
    }
    if (res.status === 200) {
      const code = res.data.code;
      if (code !== 0) {
        errorHandle(code, res.data.message);
      }
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res.data);
    }
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      if (!window.navigator.onLine) {
        // store.commit("changeNetwork", false);
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
  }
);

export default instance;
